import {css} from 'aphrodite';
import React from 'react';
import {Handle, Position, HandleType} from 'reactflow';

import {ROW_HANDLE_STYLES} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeDesignConstants';
import {HandleInteractionProps} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeTypes';
import {SimpleRowData} from 'ui-library/reactflow/nodes/SimpleBenchlingNode/SimpleBenchlingNodeTypes';

/**
 * Default row handle ID generator, pass in rowHandleIdGenerator to override.
 */
export function defaultRowHandleIdGenerator(rowId: string, handleType: HandleType): string {
  return `${rowId}-${handleType}`;
}

/**
 * Handles used to draw edges between rows on two nodes.
 */
export function SimpleBenchlingNodeSectionRowHandle(props: {
  rowData: SimpleRowData;
  handleType: HandleType;
  rowHandleIdGenerator?: (rowId: string, handleType: HandleType) => string | null;
  additionalProps: HandleInteractionProps;
}): JSX.Element | null {
  const handleId = props.rowHandleIdGenerator
    ? props.rowHandleIdGenerator(props.rowData.id, props.handleType)
    : defaultRowHandleIdGenerator(props.rowData.id, props.handleType);
  return handleId ? (
    <Handle
      className={css(
        ROW_HANDLE_STYLES.rowHandle,
        props.handleType === 'target' ? ROW_HANDLE_STYLES.leftHandle : ROW_HANDLE_STYLES.rightHandle
      )}
      type={props.handleType}
      position={props.handleType === 'target' ? Position.Left : Position.Right}
      id={handleId}
      {...props.additionalProps}
    >
      <div className={css(ROW_HANDLE_STYLES.handleDot)} />
    </Handle>
  ) : null;
}
